module.exports = __webpack_public_path__ + "static/media/se_2.78d65860.wav";